export default __webpack_public_path__ + "static/media/collaboration.dc1fac56.png";